import type { SupportedLanguage } from '../../types/supportedLanguage.types';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const getSafeLanguage = (language: string): SupportedLanguage => {
  const supportedLanguages: SupportedLanguage[] = ['en', 'de', 'es'];
  const safeLanguage = language.toLowerCase() as SupportedLanguage;

  return supportedLanguages.includes(safeLanguage)
    ? safeLanguage
    : DEFAULT_LANGUAGE;
};